import { Link } from "react-router-dom";
import { newsArticles } from "@/mocks/newsArticles";
import { formatHeat } from "@/utils/news";

function FeaturedSection() {
  const feature = newsArticles[0];
  const sideList = newsArticles.slice(1, 5);

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="mb-8">
        <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700 tracking-[0.2em]">
          <span className="w-6 h-px bg-accent-500" />
          EDITOR&apos;S PICK
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">
          主编精选 · 一次看懂来龙去脉
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
          不只是甩一条爆料，我们把前因后果、时间节点和各方表态排好，让你不用在评论区里拼线索。
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <article className="lg:col-span-7 group bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col transition-colors hover:border-primary-300">
          <Link
            to={`/article/${feature.id}`}
            className="relative w-full h-64 md:h-80 overflow-hidden cursor-pointer"
            aria-label={feature.title}
          >
            <img
              src={feature.coverImage}
              alt={feature.title}
              title={`${feature.title} - 瓜圈速报深度整理`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-[11px] font-bold">
                  持续追踪
                </span>
                <span className="px-2 py-1 rounded-md bg-background-50/20 text-background-50 text-[11px] font-medium backdrop-blur">
                  {feature.categoryName}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-black text-background-50 leading-snug">
                {feature.title}
              </h3>
            </div>
          </Link>
          <div className="p-5 md:p-6 flex flex-col flex-1">
            <p className="text-sm leading-relaxed text-foreground-600">{feature.summary}</p>
            <div className="mt-auto pt-5 flex items-center justify-between">
              <span className="text-xs text-foreground-500">{feature.publishedAt}</span>
              <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-line" />
                </span>
                {formatHeat(feature.heat)} 热度
              </span>
            </div>
          </div>
        </article>

        <div className="lg:col-span-5 flex flex-col gap-5">
          {sideList.map((item, idx) => (
            <article
              key={item.id}
              className="group flex gap-4 bg-background-50 border border-background-200 rounded-lg p-4 transition-colors hover:border-primary-300 flex-1"
            >
              <Link
                to={`/article/${item.id}`}
                className="relative shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-md overflow-hidden cursor-pointer"
                aria-label={item.title}
              >
                <img
                  src={item.coverImage}
                  alt={item.title}
                  title={`${item.title} - 瓜圈速报`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </Link>
              <div className="flex-1 min-w-0 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] font-heading font-black text-accent-600">
                    {String(idx + 2).padStart(2, "0")}
                  </span>
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px]">
                    {item.categoryName}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950">
                  <Link to={`/article/${item.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                    {item.title}
                  </Link>
                </h3>
                <span className="mt-auto pt-3 text-xs text-foreground-500">{item.publishedAt}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedSection;